var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    style: {
      fillRule: "evenodd"
    },
    d: "M44.988 53.115a375.687 375.687 0 01-4.213 7.726 3.776 3.776 0 01-6.631-.094c-5.56-9.98-16.191-30.001-16.191-37.883C17.953 12.176 26.712 3.5 37.5 3.5c10.789 0 19.548 8.676 19.548 19.364 0 .05 0 .1-.002.152-.06 3.583-2.214 9.551-5.071 15.937-2.13 4.76-6.987 14.162-6.987 14.162zM37.5 14.751c3.942 0 7.143 3.171 7.143 7.076 0 3.906-3.2 7.076-7.143 7.076-3.942 0-7.143-3.17-7.143-7.076 0-3.905 3.2-7.076 7.143-7.076z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M54.132 53.095c7.56 1.826 12.511 4.863 12.511 8.298 0 1.658-1.155 3.224-3.2 4.605"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M51.605 70.237c-4.18.804-8.99 1.262-14.104 1.262-16.086 0-29.144-4.529-29.144-10.106 0-3.435 4.951-6.472 12.511-8.298"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocations);
export default __webpack_public_path__ + "static/media/locations.78bb315c4a51436d1787ecb01b105a9f.svg";
export { ForwardRef as ReactComponent };